import React from 'react'
import MyMedicienLog from '../Components/MedicineLog/MyMedicienLog'

const MyMedicineLogView = () => {
  return (
    <div>
        <MyMedicienLog />
    </div>
  )
}

export default MyMedicineLogView